import React, { useEffect } from "react";
import ReactStars from "react-rating-stars-component";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import logoWhite from "../../assets/img/logo-white.png";
import logo from "../../assets/img/logo.png";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
const DetailsPage = () => {
  const { plan_name } = useParams();
  const find = useSelector((state) =>
    state.listMyPlan.listMyPlan.find((list) => list.plan_name === plan_name)
  );
  useEffect(() => {
    document.title = `${find.plan_name}`;
  }, [find.plan_name]);
  const ratingChanged = (newRating) => {
    console.log(newRating);
  };
  const theme = useSelector(state=>state.theme.theme);
  return (
    <>
      <Header />
      <div className="details_wrapper">
        <div className="container">
          <div className="details_container">
            <div className="preview_field">
              {find.plan_name?.length > 0 && (
                <div className="plan_name">
                  <h2>{find.plan_name}</h2>
                  <img src={theme === "dark" ? logo : logoWhite } width="100%" alt="logo" />
                </div>
              )}
              <div className="preview_item">
                {find.plan_name && (
                  <>
                    <span>Plan Name</span>
                    <h2>{find.plan_name}</h2>
                  </>
                )}
              </div>
              <div className="preview_item">
                {find.plan_category && (
                  <>
                    <span>Plan Category</span>
                    <p>{find.plan_category}</p>
                  </>
                )}
              </div>
              <div className="preview_item">
                {find.plan_webbsite && (
                  <>
                    <span>Plan Url</span>
                    <p>{find.plan_webbsite}</p>
                  </>
                )}
              </div>
              <div className="preview_item">
                {find.joining_package && (
                  <>
                    <span>Joining Package</span>
                    <p>{find.joining_package && find.joining_package + "₹"}</p>
                  </>
                )}
              </div>
              <div className="preview_item">
                {find.income_types.length > 0 && (
                  <>
                    <span>Types of incoome</span>
                    <p>
                      {find.income_types?.map((d, i) => (
                        <span
                          style={{
                            fontWeight: "500",
                            fontSize: "14px",
                            color: "#ff0000",
                          }}
                          key={i + 1}
                        >
                          {d},{" "}
                        </span>
                      ))}
                    </p>
                  </>
                )}
              </div>
              <div className="preview_item">
                {find.explainincome_type && (
                  <>
                    <span>Explain Income Type</span>
                    <p>{find.explainincome_type}</p>
                  </>
                )}
              </div>
              <div className="preview_item">
                {find.service_product && (
                  <>
                    <span>Service/Product</span>
                    <p>{find.service_product}</p>
                  </>
                )}
              </div>
              <div className="preview_item">
                {find.referral && (
                  <>
                    <span>Referral Link or Code</span>
                    <p>{find.referral}</p>
                  </>
                )}
              </div>
              <div className="preview_item">
                {find.plan_pdf && (
                  <>
                    <span>Plan PDF</span>
                    <p>{find.plan_pdf}</p>
                  </>
                )}
              </div>
              <div className="preview_item">
                {find.contact_us && (
                  <>
                    <span>Contact</span>
                    <p>{find.contact_us}</p>
                  </>
                )}
              </div>
              <div className="preview_item">
                {find.more_info && (
                  <>
                    <span>More Information</span>
                    <p>{find.more_info}</p>
                  </>
                )}
              </div>
              <div className="preview_item">
                {find.date && (
                  <>
                    <span>Date</span>
                    <p>{find.date}</p>
                  </>
                )}
              </div>
            </div>
            <div className="rating_field">
              <h2>Leave Rating</h2>
              <ReactStars
                count={5}
                onChange={ratingChanged}
                size={24}
                isHalf={true}
                emptyIcon={<i className="far fa-star"></i>}
                halfIcon={<i className="fa fa-star-half-alt"></i>}
                fullIcon={<i className="fa fa-star"></i>}
                activeColor="#ffd700"
              />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default DetailsPage;
